<div id="women">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card shadow-lg">
                    <h4 class="card-title text-center">Women Cell</h4>
                    <div class="card-body">
                        <p class="lead text-justify">
                            Women cell of the college is managed by senior teachers from all faculties and it organizes
                            programs on various issues such as Women Empowerment, Gender Sensitization, Beti Bachao Beti
                            Padhao, Women Literacy, Women Safety, Women Fitness and health awareness for all the girl
                            students of college.
                        </p>
                        <p class="lead text-justify">
                            The programs are usually in the form of expert-talks, seminars, rallies, declamations,
                            debates, slogan writing, poetical & painting competitions & workshops.
                        </p>

                        <div class="row">
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/1.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/2.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/3.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/4.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/5.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/6.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/7.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/8.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/9.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/10.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/11.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/12.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>

                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/13.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>
                            <div class="col-6 col-md-6 col-lg-6 mt-3">
                                <img src="/assets/img/women/cell/14.jpeg" alt="women" class="img-fluid rounded h250">
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- <div id="women">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card shadow-lg">
                    <h4 class="card-title text-center">Women Cell</h4>
                    <div class="card-body">
                        <p class="lead text-justify">Women cell of the college is managed by senior teachers from all faculties and it organizes programs on various issues such as Women Empowerment, Gender Sensitization, Beti Bachao Beti Padhao, Women Literacy, Women Safety, Women Fitness and health awareness for all the girl students of college. 
                        </p>
                        <p class="lead text-justify">The programs are usually in the form of expert-talks, seminars, rallies, declamations, debates, slogan writing, poetical & painting competitions & workshops.
                        </p>
                         <div class="row">
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/1.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/2.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/3.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/4.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/5.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/6.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/7.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/8.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/9.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/10.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/11.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/12.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/13.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                            <div class="col-sm-6 mt-3">
                                <img src="/assets/img/women/cell/14.jpeg" alt="women" class="img-fluid rounded">
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

       
    </div>
</div> -->